import React, { Component } from 'react'
import HttpServices from '../../../utils/Http.services'
import CustomLoader from '../../CustomLoader'
import FixedView from '../../FixedView'
import { checkTranslation, translate } from '../../../utils/useful'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import * as actions from '../../../stores/actionsList';

class MessengerTopics extends Component {

    state = {
        permissions: [
            { title: "{{lang}}messenger.Send Messages" },
            { title: "{{lang}}messenger.Send Media" },
            { title: "{{lang}}messenger.Add Members" },
            { title: "{{lang}}messenger.Create Topics" },
            { title: "{{lang}}messenger.Pin Messages" },
            { title: "{{lang}}messenger.change Group info" },
        ],
        topic: "",
        isLoader: false,
    }

    createTopic = (messenger) => {
        let users = []
        let data = {}
        this.setState({ isLoader: true })
        if (this.form1) {
            users = this.form1.getForm()
            data.users = users
        }
        data.topic = this.state.topic
        data.messenger = messenger
        HttpServices.request('createTopic', data, (fetchResult, fetchError) => {

            this.setState({ isLoader: false })
        })
    }

    hide = () => {
        this.firstView.hideView()
    }

    openFirstView = () => {
        this.firstView.showView()
    }

    changeValue = (key, value) => {
        this.setState({ [key]: value })
    }

    render() {
        let mainMessenger = this.props.messenger?.parent ? this.props.messenger?.parent : this.props.messenger
        let mainNotifcount = this.props.inbox?.messengers?.[mainMessenger?._id]?.count
        let totalNotifCount = this.props.inbox?.messengers?.[mainMessenger?._id]?.totalCount

        return (
            <div className='h-100' ref={el => this.firstCurrentNode = el}>
                <button className=" flexcc position-relative" onClick={() => this.openFirstView()}>
                    <img src={'/assets/icons/messenger/Topic-black.svg'} style={{ transition: '0.3s all' }} height={30} alt='' />
                    {(totalNotifCount > 0) && (

                        <div className='white flexcc px-1' style={{ borderRadius: 20, lineHeight: 1, minWidth: "14px", minHeight: "14px", backgroundColor: '#0085ffcc', left: 0, bottom: 0, position: 'absolute' }}>
                            <span className='font-size-10'>{totalNotifCount}</span>
                        </div>

                    )}
                </button>
                <FixedView ref={el => this.firstView = el} nodeRef={this.firstCurrentNode} showFocus={false} topOffset={20} bottomOffset={36} xOffset={-10} zIndex={10} >

                    {!this.state.isLoader ? (
                        <div className='white-bg shadow-3 br-10 p-2' style={{ overflow: 'auto', width: 250, maxHeight: 300 }}>
                            <div className='d-flex flex-column w-100 pb-1' style={{ borderBottom: '1px solid #eee' }}>

                                <p className='text-bold font-size-15 mb-1 px-2 pt-1'>{translate("Topics")}</p>

                                <div className='w-100 flexcb   px-2 py-2 br-5 hover-gray2' style={{ cursor: 'pointer', background: this.props.messenger?._id == mainMessenger?._id ? '#f2f2f2' : null }} onClick={() => this.props.setTopic(mainMessenger)}>
                                    <button className='text-start  ' >
                                        <div className=' w-100'>
                                            <div>
                                                <p className='font-size-14 text-semibold'>{checkTranslation('{{lang}}Main')}</p>
                                            </div>
                                        </div>
                                    </button>
                                    {mainNotifcount > 0 && (
                                        <div className='white flexcc' style={{ borderRadius: 20, lineHeight: 1, minWidth: "20px", minHeight: "20px", backgroundColor: '#0085ff', right: 0 }}>
                                            <span className='text-smaller'>{mainNotifcount}</span>
                                        </div>
                                    )}
                                </div>


                                {this.props.topics?.map((prop, index) => {
                                    let notifcount = this.props.inbox?.messengers?.[prop._id]?.count
                                    return (
                                    <button className='w-100 flexcb   px-2 py-2 br-5 hover-gray2' style={{ cursor: 'pointer', background: this.props.messenger?._id == prop._id ? '#f2f2f2' : null }} onClick={() => this.props.setTopic(prop)}>
                                            <div className='text-start  ' >
                                                <div className=' w-100'>
                                                    <div>
                                                        <p className='font-size-14 text-semibold'>{checkTranslation(prop['name'])}</p>
                                                        {/* <div className='flexc mt-1' style={{ marginLeft: "-2px" }}>
                                                        <img className='mrd-1' width={20} src={prop.sicon} />
                                                        <p className='font-size-10' style={{ color: "#0085FF" }}>{prop?.status}</p>
                                                    </div> */}
                                                    </div>
                                                </div>
                                            </div>
                                            {notifcount > 0 && (
                                                <div className='white flexcc' style={{ borderRadius: 20, lineHeight: 1, minWidth: "20px", minHeight: "20px", backgroundColor: '#0085ff', right: 0 }}>
                                                    <span className='text-smaller'>{notifcount}</span>
                                                </div>
                                            )}
                                        </button>
                                    )
                                })}
                            </div>
                            {/* <button className='text-start px-2 mt-2 py-1 hover-gray br-5 w-100 flexc ' onClick={this.props.openTopics}>
                                <img width={24} src='/assets/icons/plus-blue.svg' />
                                <p className='font-size-12 main-cb'>{translate('messenger.Add topic')}</p>
                            </button> */}

                            <button className='text-start px-2 mt-2 py-1 hover-gray br-5 w-100 flexc ' onClick={this.props.openTopics}>
                                <img width={24} src='/assets/icons/plus-blue.svg' alt='' />
                                <p className='font-size-12 main-cb'>{translate('Manage topic')}</p>
                            </button>

                        </div>
                    ) : (
                        <div className='h-100 flexcc'>
                            <CustomLoader color={"#007aff"} isLoading={true} />
                        </div>
                    )
                    }
                </FixedView>
            </div >
        )
    }
}

const mapStateToProps = state => ({ settings: state.settings, user: state.user, messengers: state.messengers, inbox: state.inbox })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { forwardRef: true }
)(MessengerTopics);